import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SelectItem from '../SelectItem/SelectItem';

export const SelectListContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: ${(props) => (props.mb ? `${props.mb}px` : 0)};
  margin-top: ${(props) => (props.mt ? `${props.mt}px` : 0)};
  padding-left: ${(props) => (props.pl ? `${props.pl}px` : 0)};
`;

const SelectList = ({ options, isChooseApp, mt, mb }) => (
  <SelectListContainer mt={mt} mb={mb}>
    {options.map(
      ({
        title,
        subtitle,
        description,
        onClick,
        showDivider,
        list,
        disabled,
        selected,
        dataCy,
      }) => (
        <SelectItem
          key={title}
          title={title}
          subtitle={subtitle}
          description={description}
          onClick={onClick}
          showDivider={showDivider}
          list={list}
          disabled={disabled}
          selected={selected}
          isChooseApp={isChooseApp}
          dataCy={dataCy}
        />
      ),
    )}
  </SelectListContainer>
);

SelectList.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})),
  isChooseApp: PropTypes.bool,
  mt: PropTypes.number,
  mb: PropTypes.number,
};

export default SelectList;
